// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { GraphQLError } from 'graphql';
export const createGraphQLResultWithError = (error) => {
    return {
        data: {},
        errors: [new GraphQLError(error.message, null, null, null, null, error)],
    };
};
